/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import logo from "assets/images/profile_icon.png";
import { useIntl } from "react-intl";

import { useSelector } from "react-redux";
import { StoreType } from "../types/genericTypes";

import ModalComponent from "components/Modal";
import Footer from "examples/Footer";
import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import CategoriaModulo from "components/VistaModulos/CategoriaModulo";
import { FormikProvider } from "formik";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { Spinner } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import { useAlmacen } from "hooks/useAlmacen";
import Ubicacion from "components/VistaModulos/Ubicacion";
import { useUbicacion } from "hooks/useUbicacion";

function UbicacionPage(): JSX.Element {
  const idUsuario = useSelector((state: StoreType) => state?.app?.user?.data?.id_usuario || false);

  const {
    intl,
    formik,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    ubicaciones,
    almacenes,
    //crear categoria
    isAlertOpenCrearUbicacion,
    handleisAlertCrearUbicacionOpen,
    handleisAlertCrearUbicacionClose,
    getFieldColor,
    procesandoUbicacion,
    createUbicacion,
    desactivarUbicacion,
    activarUbicacion,
    editarUbicacion,
    verEditarUbicacion,
    isAlertOpenEditarUbicacion,
    handleisAlertOpenEditarUbicacion,
    handleisAlertCloseEditarUbicacion,
    setVerEditarUbicacion,
    ubicacionesPaginadas,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    buscador,
    handleBuscadorChange,
  } = useUbicacion();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%", mt: 1 }}
            >
              <Typography variant="h4" gutterBottom>
                Ubicaciones
              </Typography>
            </Grid>
            <Grid>
              <Ubicacion
                verUbicaciones={ubicaciones}
                desactivarUbicacion={desactivarUbicacion}
                activarUbicacion={activarUbicacion}
                handleisAlertCrearUbicacionOpen={handleisAlertCrearUbicacionOpen}
                handleisAlertOpenEditarUbicacion={handleisAlertOpenEditarUbicacion}
                setVerEditarUbicacion={setVerEditarUbicacion}
                ubicacionesPaginadas={ubicacionesPaginadas}
                page={page}
                rowsPerPage={rowsPerPage}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                buscador={buscador}
                handleBuscadorChange={handleBuscadorChange}
              />
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/*<Footer />*/}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
      {/* MODAL PARA AÑADIR CATEGORÍA */}
      <ModalComponent
        handleClose={handleisAlertCrearUbicacionClose}
        isOpen={isAlertOpenCrearUbicacion}
        key={"alerta-crear-Ubicacion"}
      >
        <FormikProvider value={formik!}>
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} md={12} mt={2}>
              <Typography variant="h5" color="primary" gutterBottom sx={{ color: "#004c93", textAlign: "center" }}>
                Registrar Ubicación
              </Typography>
            </Grid>
            <br />
            <Grid item xs={6} sm={6} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                id="id_almacen"
                select
                fullWidth
                label={`${intl.formatMessage({ id: "select_almacen" })} *`}
                variant="standard"
                name="id_almacen"
                value={formik.values.id_almacen || ""}
                disabled={!almacenes || almacenes.length === 0}
                helperText={
                  !almacenes || almacenes.length === 0
                    ? intl.formatMessage({ id: "sin_almacenes_registrados" })
                    : formik.touched.id_almacen && formik.errors.id_almacen
                }
                error={formik.touched.id_almacen && Boolean(formik.errors.id_almacen)}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("id_almacen", value);
                }}
                InputProps={{
                  style: { padding: "5px" },
                }}
                onBlur={formik.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("id_almacen"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("id_almacen"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("id_almacen"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("id_almacen"),
                  },
                }}
              >
                {almacenes?.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                id="clave"
                fullWidth
                label={`${intl.formatMessage({ id: "input_clave" })}`}
                variant="standard"
                name="clave"
                value={formik.values.clave || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("clave", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.clave && Boolean(formik.errors.clave)}
                helperText={formik.touched.clave && formik.errors.clave}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("clave"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("clave"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("clave"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("clave"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="nombre"
                fullWidth
                label={`${intl.formatMessage({ id: "input_nombre" })}`}
                variant="standard"
                name="nombre"
                value={formik.values.nombre || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("nombre", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                helperText={formik.touched.nombre && formik.errors.nombre}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("nombre"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("nombre"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("nombre"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("nombre"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="descripcion"
                fullWidth
                label={`${intl.formatMessage({ id: "input_descripcion" })}`}
                variant="standard"
                name="descripcion"
                value={formik.values.descripcion || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("descripcion", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.descripcion && Boolean(formik.errors.descripcion)}
                helperText={formik.touched.descripcion && formik.errors.descripcion}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("descripcion"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("descripcion"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("descripcion"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("descripcion"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button
                sx={{ color: "#fff", background: "#084d6e" }}
                variant="contained"
                endIcon={<AddBoxIcon />}
                disabled={procesandoUbicacion}
                onClick={(e: any) => {
                  const datos = {
                    id_almacen: formik.values.id_almacen,
                    clave: formik.values.clave,
                    nombre: formik.values.nombre,
                    descripcion: formik.values.descripcion,
                    id_usuario: idUsuario,
                  };
                  //console.log(idUsuario);
                  createUbicacion(datos);
                }}
              >
                {procesandoUbicacion ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {intl.formatMessage({ id: "general_añadiendo" })}...{" "}
                  </>
                ) : (
                  intl.formatMessage({ id: "general_añadir" })
                )}
              </Button>
            </Grid>
          </Grid>
        </FormikProvider>
      </ModalComponent>
      {/* MODAL PARA EDITAR LA CATEGORÍA */}
      <ModalComponent
        handleClose={handleisAlertCloseEditarUbicacion}
        isOpen={isAlertOpenEditarUbicacion}
        key={"alertaEditarUbicacion"}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          {verEditarUbicacion && (
            <>
              <Grid item xs={12} mt={2}>
                <h5>Editando ubicación</h5>
              </Grid>
              <Grid item xs={6} sm={4} sx={{ position: "relative" }}>
                <TextField
                  id="editaClave"
                  fullWidth
                  label={intl.formatMessage({ id: "input_clave" })}
                  variant="standard"
                  name="editaClave"
                  value={formik.values.clave || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    formik.setFieldValue("clave", value);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={4} sx={{ position: "relative" }}>
                <TextField
                  id="editaNombre"
                  fullWidth
                  label={intl.formatMessage({ id: "input_nombre" })}
                  variant="standard"
                  name="editaNombre"
                  value={formik.values.nombre || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    formik.setFieldValue("nombre", value);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={4} sx={{ position: "relative" }}>
                <TextField
                  id="editaDescripcion"
                  fullWidth
                  label={intl.formatMessage({ id: "input_descripcion" })}
                  variant="standard"
                  name="editaDescripcion"
                  value={formik.values.descripcion || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    formik.setFieldValue("descripcion", value);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Button
                  sx={{ color: "#fff", background: "#084d6e" }}
                  variant="contained"
                  endIcon={<EditIcon />}
                  disabled={procesando}
                  onClick={(e: any) => {
                    const datos = {
                      id_ubicacion: verEditarUbicacion?.id_ubicacion,
                      clave: formik.values.clave,
                      nombre: formik.values.nombre,
                      descripcion: formik.values.descripcion,
                    };
                    editarUbicacion(datos);
                  }}
                >
                  {procesandoUbicacion ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      {intl.formatMessage({ id: "general_editando" })}...{" "}
                    </>
                  ) : (
                    intl.formatMessage({ id: "general_editar" })
                  )}
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </ModalComponent>
    </DashboardLayout>
  );
}

export default UbicacionPage;
